module.exports = __webpack_public_path__ + "img/engagement@2x.e2873cb.jpg";